<template>
  <div class="gray-back" style="padding:.2rem 0 1rem 0">
    <div v-rblink="{name:'DakejianApply',query:{}}" style="padding: 10px;">
      <img style="width: 100%; " src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230425/user-0/20230425/a1bd4950e71614d8d809ed975938d3a0.jpeg?x-oss-process=style/tb-750"/>
    </div>
    <van-form
        @submit="onSubmit"
        @failed="onFailed"
        class="step-one" v-if="!isStepTwo"
    >
        <van-cell-group>
          <van-field name="radio" label="活动"
                     input-align="right">
            <template #input>
              <van-radio-group v-model="formData.leixing" direction="horizontal">
                <van-radio checked-color="#ffb01b" name="2023年‘奔跑吧·少年’全国啦啦操大课间展示活动">2023年‘奔跑吧·少年’全国啦啦操大课间展示活动</van-radio>
                <!--              <van-radio checked-color="#ffb01b" name="学校俱乐部">学校俱乐部</van-radio>-->
              </van-radio-group>
            </template>
          </van-field>

          <van-field name="radio" label="单位类型"

                     :rules="[{ required: true, message: '请选择单位类型' }]"
                      input-align="right">
              <template #input>
                  <van-radio-group v-model="formData.type" direction="horizontal">
                      <van-radio checked-color="#ffb01b" name="大学">大学</van-radio>
                      <van-radio checked-color="#ffb01b" name="中学">中学</van-radio>
                      <van-radio checked-color="#ffb01b" name="小学">小学</van-radio>
                      <van-radio checked-color="#ffb01b" name="幼儿园">幼儿园</van-radio>
                      <van-radio checked-color="#ffb01b" name="其他">其他</van-radio>
                  </van-radio-group>
              </template>
          </van-field>


          <van-field
              readonly
              clickable
              name="area"
              :value="formData.county?formData.province+'/'+formData.city+'/'+formData.county:''"
              input-align="right"
              label="地区选择"
              placeholder="点击选择省市区"
              @click="showArea = true"
          />
          <van-popup v-model="showArea" position="bottom">
            <van-area
                :area-list="areaList"
                :value="formData.area"
                @confirm="onAreaConfirm"
                @cancel="showArea = false"
            />
          </van-popup>

          <!-- <van-field
              readonly
              clickable
              :value="formData.extra_danwei.length ? formData.extra_danwei[0].name : ''"
              autosize
              type="textarea"
              input-align="right"
              label="单位名称"
              placeholder="点击选择可申报的单位"
              @click="showDanweiPicker = true"
          /> -->

                 <van-field
                     v-model="formData.danwei"
                     :rules="[{ required: true, message: '请输入准确的单位全称' }]"
                     label="单位名称"
                     input-align="right"
                     error-message-align="right"
                     clearable
                     placeholder="请输入准确的单位全称"
                />
          <van-field
              v-model="formData.address"
              :rules="[{ required: true, message: '请输入详细地址' }]"
              error-message-align="right"
              label="详细地址"
              input-align="right"
              clearable
              placeholder="请输入详细地址"
          />
          <van-field
              v-model="formData.express_name"
              :rules="[{ required: true, message: '请输入邮寄联系人及电话' }]"
              error-message-align="right"
              label="邮寄联系人及电话"
              input-align="right"
              clearable
              placeholder="请输入邮寄联系人及电话"
          />

        </van-cell-group>

        <van-divider>啦啦操推广大使</van-divider>
        <van-cell-group>
          <van-field
              v-model="formData.name"
              :rules="[{ required: true, message: '请输入姓名' }]"
              error-message-align="right"
              label="个人姓名（限1人）"
              input-align="right"
              clearable
              placeholder="请输入姓名"
          />
          <!--        <div class="operate-desc-left" >限一人</div>-->
        </van-cell-group>

        <van-divider>联系人信息</van-divider>
        <van-cell-group>
          <van-field
              v-model="formData.contactsname"
              :rules="[{ required: true, message: '请输入联系人姓名' }]"
              error-message-align="right"
              label="联系人姓名"
              input-align="right"
              clearable
              placeholder="请输入联系人姓名"
          />
          <van-field
              v-model="formData.contactsphone"
              :rules="[{ required: true, message: '请输入联系人手机' }]"
              error-message-align="right"
              label="联系人手机"
              input-align="right"
              clearable
              placeholder="请输入联系人手机"
          />
        </van-cell-group>

        <van-divider>加群二维码</van-divider>
        <div style="width: 80%; text-align: center ; margin: 0px auto 20px;  font-size:14px;">
          <img style="width: 100%;" src="https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230429/user-0/20230429/e19b2f59f724ae09aa7db37bccd95495.png"/>
          <van-button  v-if="!isApp" style="margin: 10px auto; text-align: center " type="default" native-type="button" round>请长按图片保存</van-button>
          <van-button
              v-else
              native-type="button"
              color=""
              style="width: 3rem"
              size="normal" round @click="download">下载二维码
          </van-button>
        </div>

        <div class="savebtn">
          <van-button
              style="width: 3rem"
              native-type="button"
              size="normal" round v-rblink="{name: 'DakejianApplyList'}">
            申报列表
          </van-button>
          <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="true" :loading="saveLoading" loading-text="提交中..."  >
            申报已截止
          </van-button>
          <!-- <van-button
              color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
              style="width: 3rem"
              size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
            提交申报
          </van-button> -->
        </div>
    </van-form>

    <van-form
        @submit="onSubmitThree"
        @failed="onFailed"
        class="step-two"
        v-else
    >
        <van-divider>全国校园大课间啦啦操优秀参与奖</van-divider>


      <div class="savebtn">
      <van-button
          native-type="button"
          color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
          style="
    bottom: 80px;
    right: 10px;
    z-index: 10;
    position: fixed;"
          size="normal" round
          round @click.native="showTemplate = true">导入模板
      </van-button>
        <van-button
            color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
            style="width: 3rem"
            size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">
          提交申请
        </van-button>
      </div>
    </van-form>


    <van-dialog v-model="showTemplate" title="导入模板信息">
      <div class="operate-desc-left">复制下面的链接，用电脑端打开，进行批量导入操作</div>
      <!--      <div class="operate-desc-left" @click="download" style="color: #1989fa;">考级人员批量导入模版下载</div>-->
      <div class="operate-desc-left" v-clipboard:copy="row.share"
           v-clipboard:success="onCopy"
           v-clipboard:error="onError" style="color: #666">导入模板链接地址：{{ row.share }}
        <div class="small-button">复制</div>
      </div>
      <!--        <div class="operate-desc-left" @click="download" style="color: #1989fa;">训练营报名批量导入模版下载</div>-->
    </van-dialog>


    <DakejianDanweiPicker
        :show="showDanweiPicker"
        :limit="1"
        :value="formData.extra_danwei"
        @onChange="onDanweiChange"
        @onClose="showDanweiPicker=false"
        :defaultValue="formData.extra_danwei"
        @onConfirm="onDanweiConfirm"
    ></DakejianDanweiPicker>

    <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel"/>

  </div>
</template>
<style scoped>
.box {
  /*margin-bottom: 1.5rem;*/
}

.small-button {
  height: 30px;
  padding: 0 8px;
  font-size: 12px;
  line-height: 30px;
  color: #323233;
  background-color: #fff;
  border: 1px solid #ebedf0;
  display: inline-block;
}

.savebtn {
  position: fixed;
  bottom: 0;
  padding-bottom: 0.2rem;
  width: 100%;
  z-index: 10;
  display: flex;
  flex: 1;
  flex-direction: row;
  justify-content: space-around;
  background: linear-gradient(180deg, hsla(0, 0%, 100%, 0), #fff);
}


.van-tag {
  width: 55px;
  margin-left: 10px;
  text-align: center;
}

.between {
  justify-content: space-between;
}


</style>
<script>
import Vue from 'vue';
import area from "../../../utils/area";
import validator from "../../../utils/validator";
import PicUploader from '@/components/picker/PicUploader.vue';
import LoginDialog from "@/components/LoginDialog.vue";
import DakejianDanweiPicker from '@/components/picker/DakejianDanweiPicker.vue';

import {
  Cell,
  Field,
  Area,
  Form,
  Divider,
  CellGroup,
  RadioGroup,
  Radio,
  Icon,
  Toast,
  Popup,
  Picker,
  Sidebar,
  SidebarItem,
  Tag,
  Stepper,
  Switch,
  Button
} from 'vant';

Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
    .use(Switch).use(Button);
export default {
  name: 'DakejianApply',
  components: {
    PicUploader, LoginDialog, DakejianDanweiPicker
  },
  data: function () {
    return {
      validator,
      loginShow: false,
      saveLoading: false,
      showArea: false,
      showDanweiPicker: false,
      showTemplate: false,
      isStepTwo: false, // 是否是第二步操作
      areaList: {},
      areaValue: '',
      submitType: '',
      formData: {
        id: 0,
        areas: '',
        province: '',
        contactsname: '',
        contactsphone: '',
        leixing: '2023年‘奔跑吧·少年’全国啦啦操大课间展示活动',
        qq: '',
        city: '',
        county: '',
        extra_danwei: []
      },

      row: {},
      isApp: window.isApp()
    }
  },
  filters: {},
  mounted() {
    document.title = "大课间展演申报"
    let that = this;
    that.areaList = area;
    that.formData.id = this.$route.query.id;
    that.getUserDetail();
//             this.fetch();
//            }
  },
  watch: {
    formData() {
    }
  },
  destroyed() {
  },
  methods: {
    download() {
      appEvent({
        name: 'downloadPic',
        query: {
          filename: '大课间展演加群二维码.png',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20230429/user-0/20230429/e19b2f59f724ae09aa7db37bccd95495.png',
        }
      });
    },
    getUserDetail() {
      let that = this;
      this.$api.get('/api/user/userPage', {}, (res) => {
        console.log(res)
      }, (res) => {
        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        } else {
          Toast(res.msg)
        }
      })
    },

    onCopy(e) {
      Toast.success('复制成功');
    },
    onError(e) {
      console.log('复制失败！');
    },

    onDanweiChange(values) {
      console.log('onDanweiChange', values)
      this.formData.extra_danwei = [...values];
    },
    onDanweiConfirm(values) {
      console.log('onDanweiConfirm', values)
      this.showDanweiPicker = false;
      this.formData.extra_danwei = [...values];
    },

    loginSuccess(res) {
      console.log("-------登录成功--------", res);
      this.getUserDetail();
      this.loginShow = false;
    },

    loginCancel() {
      console.log("-------取消登录--------");
      // this.loginShow = false;
    },
    onQuestion() {
      console.log('onQuestion')
    },
    onAreaConfirm(values) {
      console.log(values);
      this.formData.area = values[2].code;
      this.formData.province = values[0].name;
      this.formData.city = values[1].name;
      this.formData.county = values[2].name;
      this.showArea = false;
    },
    onSubmit(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      console.log(that.formData)
      that.formValidate = true;

      for (let field in that.formData) {

        if (!this.formData.area) {
          Toast('请选择地区');
          return
        }

        // if (!that.formData.extra_danwei.length) {
        //   Toast('请选择单位');
        //   return
        // }
      }
      that.saveLoading = true;

      // that.formData.danwei = that.formData.extra_danwei[0].name

      that.$api.post('/api/zdakejian/apply', that.formData, (res) => {
        that.saveLoading = false;

        that.row = res.data
        // that.isStepTwo = true
        // rbLink('DakejianApplyList');
        Toast.success('提交成功');
        setTimeout(() => {
          rbLink({
            name: "DakejianApplyList",
            query: { 
            }
          }, 'replace')
        }, 500)
      }, (res) => {

        if (res.code == 401 || res.code == 402) {
          if (window.isApp()) {
            rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
            );
            return false;
          } else {
            // Toast(res.msg);
            this.loginShow = true;
          }
        }
        Toast(res.msg);
        Toast.fail(res.msg);
        that.saveLoading = false;
      })
    },


    onSubmitThree(values) {
      console.log('onSubmit-values', values);
      console.log('submitType', this.submitType);

      let that = this;
      that.saveLoading = true;
      that.$api.post('/api/zdakejian/checkApplyMember', {
        'baoming_id': that.row.baoming_id
      }, (res) => {
        Toast.success('提交成功')
        that.saveLoading = false;
        rbLink({
          name: 'DakejianApplySuccess',
          query: {
            id:  that.row.baoming_id
          }
        })
      }, (res) => {
        Toast.fail(res.msg);
        that.saveLoading = false;
      })



    },
    save(values) {
      this.submitType = 'save';
    },
    onFailed(errorInfo) {
      console.log('failed', errorInfo);
    },
    submit(values) {
      this.submitType = 'submit';
      this.submitThreeType = 'submit'
    },

  }
}
</script>



// WEBPACK FOOTER //
// DakejianApply.vue?24c0bf26